"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = require("@polkadot/util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Staking = /*#__PURE__*/function () {
  function Staking(robonomics) {
    _classCallCheck(this, Staking);

    this.robonomics = robonomics;
  } // consts


  _createClass(Staking, [{
    key: "bondingDuration",
    value: function bondingDuration() {
      return this.robonomics.api.consts.staking.bondingDuration;
    }
  }, {
    key: "bonusReward",
    value: function bonusReward() {
      return this.robonomics.api.consts.staking.bonusReward;
    }
  }, {
    key: "stakeReward",
    value: function stakeReward() {
      return this.robonomics.api.consts.staking.stakeReward;
    } // queries

  }, {
    key: "bonded",
    value: function () {
      var _bonded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(account) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.robonomics.api.query.staking.bonded(account);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function bonded(_x) {
        return _bonded.apply(this, arguments);
      }

      return bonded;
    }()
  }, {
    key: "bonus",
    value: function () {
      var _bonus = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(account) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.robonomics.api.query.staking.bonus(account);

              case 3:
                return _context2.abrupt("return", _context2.sent.value);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", 0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function bonus(_x2) {
        return _bonus.apply(this, arguments);
      }

      return bonus;
    }()
  }, {
    key: "ledger",
    value: function () {
      var _ledger = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(account) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.robonomics.api.query.staking.ledger(account);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ledger(_x3) {
        return _ledger.apply(this, arguments);
      }

      return ledger;
    }() // extrinsics

  }, {
    key: "bond",
    value: function bond(controller, value) {
      return this.robonomics.api.tx.staking.bond(controller, value);
    }
  }, {
    key: "bondExtra",
    value: function bondExtra(value) {
      return this.robonomics.api.tx.staking.bondExtra(value);
    }
  }, {
    key: "claimRewards",
    value: function claimRewards() {
      return this.robonomics.api.tx.staking.claimRewards();
    }
  }, {
    key: "unbond",
    value: function unbond(value) {
      return this.robonomics.api.tx.staking.unbond(value);
    }
  }, {
    key: "withdrawUnbonded",
    value: function withdrawUnbonded() {
      return this.robonomics.api.tx.staking.withdrawUnbonded();
    } // events

  }, {
    key: "on",
    value: function () {
      var _on = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var filter,
            cb,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                filter = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                cb = _args4.length > 1 ? _args4[1] : undefined;
                return _context4.abrupt("return", this.robonomics.on(_objectSpread(_objectSpread({}, filter), {}, {
                  section: "staking"
                }), function (result) {
                  cb(result);
                }));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function on() {
        return _on.apply(this, arguments);
      }

      return on;
    }() // helpers

  }, {
    key: "getReward",
    value: function () {
      var _getReward = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ledger, block_number) {
        var duration, bonus, active, bonus_stake, bonus_reward, stake, stake_reward;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(block_number <= ledger.claimed_rewards)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", 0);

              case 2:
                duration = (0, _util.bnToBn)(block_number - ledger.claimed_rewards);
                _context5.next = 5;
                return this.bonus(ledger.stash);

              case 5:
                bonus = _context5.sent;

                if (bonus === 0 || bonus.isEmpty) {
                  bonus = (0, _util.bnToBn)("0");
                } else {
                  bonus.toBn();
                }

                active = (0, _util.bnToBn)(ledger.active);

                if (bonus.gt(active)) {
                  bonus_stake = active;
                } else {
                  bonus_stake = bonus;
                }

                bonus_reward = this.bonusReward().toBn().mul(bonus_stake);
                stake = active.sub(bonus_stake);
                stake_reward = this.stakeReward().toBn().mul(stake);
                return _context5.abrupt("return", bonus_reward.add(stake_reward).mul(duration).div((0, _util.bnToBn)("1000000000")).toString());

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getReward(_x4, _x5) {
        return _getReward.apply(this, arguments);
      }

      return getReward;
    }()
  }]);

  return Staking;
}();

exports["default"] = Staking;